<template>
  <!-- 订单管理 -->
  <div class="insuredOrder main-container">
    <div class="content">
      <div class="search-box btn3" :class="{ 'close': !searchMore }">
        <div class="input-item">
          <span class="label">保险公司</span>
          <Select v-model="searchParams.companyCode" :transfer="true" filterable clearable>
            <Option v-for="(item, i) in companyList" :key="i" :value="item.code">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item select-two">
          <Select v-model="searchParams.dateType" :transfer="true">
            <Option value="1">录单时间</Option>
            <Option value="2">投保日期</Option>
            <Option value="3">生效日期</Option>
            <Option value="4">支付时间</Option>
            <Option value="5">创建时间</Option>
          </Select>
          <DatePicker
            type="daterange"
            split-panels
            separator="至"
            :transfer="true"
            placement="bottom"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            :value="searchParams.date"
            @on-change="searchParams.date = $event"
          ></DatePicker>
        </div>
        <div class="input-item">
          <span class="label">订单号</span>
          <Input v-model="searchParams.orderNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">投保单号</span>
          <Input v-model="searchParams.proposalNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">订单状态</span>
          <Select v-model="searchParams.status" :transfer="true" clearable>
            <Option value="1">未支付</Option>
            <Option value="2">已付款</Option>
            <Option value="3">已退款</Option>
            <Option value="4">已失效</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item select-two">
          <Select v-model="searchParams.userType" :transfer="true">
            <Option value="1">投保人</Option>
            <Option value="2">被保险人</Option>
          </Select>
          <Input v-model="searchParams.name" placeholder="姓名/手机号" clearable />
        </div>

        <div class="input-item">
          <span class="label">业务类别</span>
          <Select v-model="searchParams.sellType" :transfer="true" clearable>
            <Option value="1">网销</Option>
            <Option value="2">电销</Option>
            <Option value="3">经代</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">是否自保件</span>
          <RadioGroup v-model="searchParams.isSelfHold" @on-change="searchAjax()">
            <Radio label="">全部</Radio>
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </div>
        <div class="input-item">
          <span class="label">是否互保件</span>
          <RadioGroup v-model="searchParams.isMutualHold" @on-change="searchAjax()">
            <Radio label="">全部</Radio>
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </div>
        <div class="input-item" v-if="userInfo.userType != 4">
          <span class="label">所属机构/团队</span>
          <selectTree type="1" v-model="searchParams.applyOrgId" @change="selectTreeChange"></selectTree>
        </div>
        <div class="input-item" v-if="userInfo.userType != 4">
          <span class="label">出单业务员</span>
          <Input v-model="searchParams.salesmanName" placeholder="请输入" clearable />
        </div>
        <div class="input-item" v-if="$units.showSupplier() && $units.pointAction('order_10_7')">
          <span class="label">供应商类型</span>
          <RadioGroup v-model="searchParams.supplierType" @on-change="changeOriginSupplierType">
            <Radio label="">全部</Radio>
            <Radio label="1">保司</Radio>
            <Radio label="2">通道</Radio>
          </RadioGroup>
        </div>
        <div v-if="searchParams.supplierType && $units.showSupplier() && $units.pointAction('order_10_7')" class="input-item">
          <span class="label">供应商</span>
          <Select v-model="searchParams.supplierIds" multiple :max-tag-count="4" clearable filterable transfer>
            <Option v-for="item in supplierList" :key="item.value" :value="item.value">{{ item.label }}</Option>
          </Select>
        </div>
        <div v-if="$units.isOkTX() || $units.isOkBao()|| $units.isRYBB()" class="input-item">
          <span class="label">推广执行人</span>
          <lzDicSelect v-model="searchParams.executer" dicType="USER_EXECUTER" :transfer="true" clearable> </lzDicSelect>
        </div>
        <div v-if="$units.isOkTX() || $units.isOkBao()|| $units.isRYBB()" class="input-item">
          <span class="label">推广渠道</span>
          <lzDicSelect v-model="searchParams.channel" dicType="USER_CHANNEL" :transfer="true" clearable> </lzDicSelect>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">搜索</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore = false"
            >收起
            <Icon type="ios-arrow-up" />
          </Button>
          <Button type="primary" ghost v-else @click="searchMore = true"
            >展开
            <Icon type="ios-arrow-down" />
          </Button>
        </div>
      </div>
      <div class="tab-box">
        <Tabs v-model="searchParams.firstTab" v-if="userInfo.userType != 4 && userInfo.isSubData" :animated="false" @on-click="toggleFirstTab">
          <TabPane label="全部订单" name="1"></TabPane>
          <TabPane label="直属团队订单" name="2"></TabPane>
          <TabPane label="下级机构订单" name="3"></TabPane>
        </Tabs>
        <div class="tools-box" v-if="$units.pointAction('order_10_2') && $units.superviseShowVal()">
          <Button type="primary" ghost @click="exportList">导出</Button>
        </div>
      </div>

      <div class="sedTab" v-if="isShowSed">
        <ul class="filterTab">
          <li :class="{ active: curActive == index }" v-for="(item, index) in sendTab" :key="index" @click="toggleSecondTab(index, item)">
            {{ item.label }}
          </li>
        </ul>
      </div>
      <div class="tipBox clearfix" v-if="$units.superviseShowVal()">
        <div class="left clearfix">
          <div>
            共
            <span class="total">{{ total }}</span
            >单
          </div>
          <div v-if="!isShowTxt && payStatus != 3 && payStatus != 1 && searchParams.secondTab != 4">
            已支付保费：
            <span class="other">{{ countObj.payedAmount }}</span
            >元
          </div>
          <div v-if="!isShowTxt && payStatus != 3 && payStatus != 1 && searchParams.secondTab != 4">
            已支付标保：
            <span class="other">{{ countObj.payedFoldFyb }}</span
            >元
          </div>

          <div v-if="payStatus != 2 && payStatus != 3">
            未支付保费：
            <span class="other">{{ countObj.noPayedAmount }}</span
            >元
          </div>
          <div v-if="payStatus != 2 && payStatus != 3">
            未支付标保：
            <span class="other">{{ countObj.noPayedFoldFyb }}</span
            >元
          </div>

          <div v-if="(payStatus != 4 && payStatus != 1 && searchParams.secondTab != 4) || searchParams.secondTab == 5">
            退款保费：
            <span class="other">{{ countObj.refundedAmount }}</span
            >元
          </div>
          <div v-if="(payStatus != 4 && payStatus != 1 && searchParams.secondTab != 4) || searchParams.secondTab == 5">
            退款标保：
            <span class="other">{{ countObj.refundedFoldFyb }}</span
            >元
          </div>
        </div>
      </div>

      <div class="table-box setTable">
        <loading :isShow="$root.$children[0].isShowLoading" />
        <Table :columns="columns" :data="tableDate">
          <template slot-scope="{ row }" slot="sellTypeSlot">
            <div class="sellTypeColumn" v-if="row.sellTypes">
              <Tag color="blue" v-if="row.sellTypes.includes('1')">网销</Tag>
              <Tag color="blue" v-if="row.sellTypes.includes('2')">电销</Tag>
              <Tag color="blue" v-if="row.sellTypes.includes('3')">经代</Tag>
            </div>
            <div v-else>-</div>
          </template>
          <template slot-scope="{ row }" slot="executer">
            <lzDicTxt v-if="row.executer" dicType="USER_EXECUTER" :dicCode="row.executer"></lzDicTxt>
            <span v-else>-</span>
          </template>
          <template slot-scope="{ row }" slot="channel">
            <lzDicTxt v-if="row.channel" dicType="USER_CHANNEL" :dicCode="row.channel"></lzDicTxt>
            <span v-else>-</span>
          </template>
          <template slot-scope="{ row }" slot="bar">
            <span @click="$refs.orderDetailModal.open({ ...row, operationFunction: 14 })" class="table-btn">详情</span>
            <span
              v-show="$units.pointAction('order_10_3') && row.status == 1 && row.checkInsuranceStatus == 1 && row.payUrl"
              @click="getPayLink(row.payUrl)"
              class="table-btn"
            >
              获取支付链接
            </span>
            <span class="table-btn" @click="jumpManualUrl(row)" v-if="$units.pointAction('order_10_4') && row.checkInsuranceStatus == 2"
              >人核进度</span
            >

            <Tooltip content="有关联保单的订单不允许删除" style="display: inline-block" v-if="row.policyNo" transfer>
              <span class="table-btn gray">删除</span>
            </Tooltip>
            <span @click="del(row)" class="table-btn red" v-else>删除</span>
          </template>
        </Table>
      </div>
      <div class="pageBox">
        <Page :total="total" :current="searchParams.pageNo" :page-size="searchParams.pageSize" show-total @on-change="pageChange" style="text-align: center" 
        show-sizer :page-size-opts="[10, 20, 30, 50, 100]" @on-page-size-change="pageSizeChange" />
      </div>
    </div>

    <!-- 订单详情 -->
    <order-detail-Modal ref="orderDetailModal"></order-detail-Modal>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
  </div>
</template>

<script>
import confirmModal from '@/components/commons/confirmModal';
import orderDetailModal from './components/orderDetailModal';
import { mapState } from 'vuex';
import _ from 'lodash';
import { pageTool } from '@/api/mixins';
import lzDicTxt from '@/components/commons/lzDicTxt';
import selectTree from '@/components/system/selectTree3';
import lzDicSelect from '@/components/commons/lzDicSelect';
import { config } from './order.config.js';
import { getOrderStatistics } from '@/api/httpList';
export default {
  mixins: [pageTool, config],
  components: {
    confirmModal,
    selectTree,
    orderDetailModal,
    lzDicSelect,
    lzDicTxt
  },
  data() {
    return {
      isShowTxt: false,
      cur: 0,
      countObj: {},
      curActive: 0,
      total: 0,
      //过滤项
      searchParams: {
        dateType: '2',
        userType: '1',
        pageNo: 1,
        pageSize: 10
      },
      sendTabbase: [
        {
          label: '全部',
          value: '1'
        },
        {
          label: '待支付',
          value: '6'
        },
        {
          label: '人工核保中',
          value: '2'
        },
        {
          label: '核保失败',
          value: '3'
        },
        {
          label: '已撤单',
          value: '4'
        },
        {
          label: '待核保',
          value: '0'
        },
        {
          label: '预核保成功',
          value: '10'
        },
        {
          label: '预核保失败',
          value: '-3'
        }
      ],
      sendTabother: [
        {
          label: '全部',
          value: '1'
        },
        {
          label: '有部分退款',
          value: '5'
        }
      ],
      isShowSed: false,
      sendTab: [],
      firstTab: '1', //一级tab
      showOrderdetail: false,
      fold: true,
      //表单搜索字段
      columns: [],
      tableDate: [],
      companyList: [],
      supplierList: []
    };
  },
  watch: {
    payStatus(value) {
      if (value == 1) {
        this.sendTab = _.cloneDeep(this.sendTabbase);
        this.isShowSed = true;
        this.isShowTxt = false;
      } else if (value == 2) {
        this.sendTab = _.cloneDeep(this.sendTabother);
        this.isShowTxt = false;
        this.isShowSed = true;
      } else if (value == 4) {
        this.isShowTxt = true;
      } else {
        this.isShowSed = false;
        this.isShowTxt = false;
      }
      this.curActive = 0;
      this.searchParams.secondTab = ''; //复位二级tab
      this.getOrder();
    }
  },
  computed: {
    ...mapState(['userInfo']),
    payStatus() {
      return this.searchParams.payStatus;
    }
  },
  methods: {
    del(item) {
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: '确定删除订单？'
        })
        .then(() => {
          this.$http({
            url: '/buz/order/order/del',
            type: 'GET',
            data: {
              id: item.id
            }
          }).then(res => {
            this.$notice.msg('删除订单成功');
            this.getOrder();
          });
        });
    },
    changeOriginSupplierType(value) {
      this.searchParams.supplierIds = [];
      if (!value) {
        this.supplierList = [];
        return;
      }
      this.$http({
        url: value == 1 ? '/buz/insuranceCompany/read/list' : '/buz/insuranceChannel/read/list',
        type: 'POST',
        data: {}
      }).then(res => {
        if (value) {
          this.supplierList = res.data.map(i => {
            return {
              value: i.id,
              label: i.name
            };
          });
        } else {
          this.supplierList = [];
        }
      });
    },
    // 获取保司列表
    getCompanyList() {
      this.$http({
        url: `/buz/insuranceCompany/read/list`,
        type: 'POST',
        data: { companyType: '1' }
      }).then(res => {
        this.companyList = res.data;
      });
    },
    // 组织选择
    selectTreeChange(data) {
      if (data.nodeType == 1) {
        //机构
        this.searchParams.orgId = data.id;
        this.searchParams.groupId = '';
      } else if (data.nodeType == 2) {
        //团队
        this.searchParams.orgId = '';
        this.searchParams.groupId = data.id;
      } else {
        this.searchParams.orgId = '';
        this.searchParams.groupId = '';
      }
    },
    // 跳转人核页面
    jumpManualUrl(row) {
      this.$http({
        url: `/buz/order/getManualUrl`,
        type: "GET",
        data:{
          orderNo: row.orderNo
        }
      }).then(res=>{
        if(!res.data) {
          this.$notice.error('人核链接不存在');
          return;
        }
        window.open(res.data);
      })
    },
    async exportList() {
      const params = this.initFilterObj();
      const res = await this.$http({
        type: 'POST',
        forced: true,
        responseType: 'blob',
        All: true,
        url: `/buz/order/export`,
        data: params,
        apiPermissionCode: 'order_10_2'
      });
      const fileName = decodeURI(res.headers['content-disposition'].split(';')[1].split('filename=')[1]);
      const blob = new Blob([res.data]); //构造一个blob对象来处理数据
      // const fileName = "xx.xls";
      //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
      //IE10以上支持blob但是依然不支持download
      if ('download' in document.createElement('a')) {
        //支持a标签download的浏览器
        const link = document.createElement('a'); //创建a标签
        link.download = fileName; //a标签添加属性
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click(); //执行下载
        URL.revokeObjectURL(link.href); //释放url
        document.body.removeChild(link); //释放标签
      } else {
        //其他浏览器
        navigator.msSaveBlob(blob, fileName);
      }
      this.$Message.success('导出成功');
    },
    getPayLink(payUrl) {
      this.$units.copyUrl(payUrl, false, false);
      this.$Message.success('订单支付链接复制成功，请在移动端打开支付');
    },
    //切换一级tab
    async toggleFirstTab() {
      if (this.searchParams.firstTab === this.copyFirstTab) return;
      this.curActive = 0;
      this.searchParams.secondTab = '1'; //复位二级tab
      this.searchParams.pageNo = 1;
      this.getOrder();
    },
    async toggleSecondTab(index, item) {
      this.curActive = index;
      this.searchParams.secondTab = item.value;
      if (this.searchParams.secondTab === this.copySecondTab) return;
      this.searchParams.pageNo = 1;
      this.getOrder();
    },
    pageChange(pageNo) {
      this.searchParams.pageNo = pageNo;
      this.getOrder();
    },
    pageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize;
      this.searchParams.pageNo = 1;
      this.getOrder();
    },
    resetSearch() {
      this.searchParams = {
        dateType: '2',
        userType: '1',
        pageNo: 1,
        pageSize: this.searchParams.pageSize,
        firstTab: '1',
        secondTab: '1',
        date: []
      };
      this.searchAjax();
    },
    //搜索
    searchAjax() {
      this.searchParams.pageNo = 1;
      this.$root.$children[0].isShowLoading = true;
      this.getOrder();
    },
    //获取订单
    async getOrder() {
      const params = this.initFilterObj();
      this.copyFirstTab = params.firstTab; //备份
      this.copySecondTab = params.secondTab;
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: '/buz/order/read/list',
        type: 'POST',
        data: params,
        apiPermissionCode: 'order_10_0'
      })
        .then(res => {
          this.tableDate = res.data;
          this.total = res.total;
          this.$root.$children[0].isShowLoading = false;
        })
        .catch(() => {
          this.$root.$children[0].isShowLoading = false;
        });
      await this.getOrderStatisticsData();
    },
    //订单统计
    async getOrderStatisticsData() {
      const params = this.initFilterObj();
      const res = await getOrderStatistics(params);
      this.countObj = res.data;
    },
    //获取最新搜索条件
    initFilterObj() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      if (params.date && params.date[0]) {
        if (params.dateType == 1) {
          //录单时间
          params.entryTimeBegin = params.date[0];
          params.entryTimeEnd = params.date[1];
        } else if (params.dateType == 2) {
          //投保日期
          params.holdTimeBegin = params.date[0];
          params.holdTimeEnd = params.date[1];
        } else if (params.dateType == 3) {
          //生效日期
          params.effectTimeBegin = params.date[0];
          params.effectTimeEnd = params.date[1];
        } else if (params.dateType == 4) {
          //支付时间
          params.payTimeStart = params.date[0];
          params.payTimeEnd = params.date[1];
        } else if (params.dateType == 5) {
          //创建时间
          params.createTimeStart = params.date[0];
          params.createTimeEnd = params.date[1];
        }
      }
      delete params.dateType;
      delete params.date;
      if (params.userType == 1) {
        //投保人
        params.holderName = params.name;
      } else if (params.userType == 2) {
        //被保险人
        params.insuranceName = params.name;
      }
      delete params.userType;
      delete params.name;

      delete params.applyOrgId;
      return params;
    }
  },

  async mounted() {
    this.getCompanyList();
  },
  activated() {
    if (this.$route.query.status) {
      this.searchParams.status = this.$route.query.status;
      this.$nextTick(() => {
        this.searchMore = true;
      });
    }
    this.getOrder();
  }
};
</script>
<style lang="scss" scoped>
/deep/ .formGroup:after {
  display: none;
}

/deep/ .ivu-form-item-content {
  color: #272933;
}

/deep/ .ivu-modal-body {
  padding: 16px 30px;
}

.my-modal /deep/ .formGroup {
  position: relative;
  padding: 0;

  &:after {
    position: absolute;
    bottom: -5px;
    width: 100%;
    height: 20px;
    content: '';
    filter: blur(5px);
    background: #fff;
  }
}

.my-modal /deep/ .title {
  width: 100%;
  padding-bottom: 10px;
  padding-top: 10px;
  font-size: 14px;
  color: #3c464f;
  font-weight: bold;
  position: relative;
  display: flex;
  align-items: center;
  white-space: nowrap;
  height: 40px;

  &::before {
    content: '';
    display: block;
    width: 3px;
    height: 12px;
    background-color: #236dff;
    margin-right: 6px;
  }

  &::after {
    content: '';
    display: block;
    background-color: #eff3fc;
    height: 1px;
    width: 100%;
    margin-left: 10px;
  }
}

@import './order.scss';

.myFormStyle /deep/ .selectStyle .ivu-select-selection {
  background-color: #f8f8f9;
}
</style>
